// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/explicit-module-boundary-types
export const doNothing = () => {
};

export const isUndefined = (variable: unknown): boolean => typeof (variable) === 'undefined';
